import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { PreEnrollmentDocument } from '../models/pre-enrollment-documents.model';

export const PreEnrollmentDocumentsActions = createActionGroup({
  source: 'Pre Enrollment Documents',
  events: {
    'Load Page Data': emptyProps(),
    'Load Page Data Success': props<{
      studyPlanName: string;
      documents: PreEnrollmentDocument[];
    }>(),
    'Load Page Data Failure': props<{ error: string }>(),
    'Upload Document': props<{ document: PreEnrollmentDocument; file: File }>(),
    'Upload Document Failure': props<{
      document: PreEnrollmentDocument;
      error: string;
    }>(),
    'Refresh Documents': emptyProps(),
    'Refresh Documents Success': props<{ documents: PreEnrollmentDocument[] }>(),
    'Refresh Documents Failure': props<{ error: string }>(),
  },
});
